/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { Typography } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Row, Col } from 'reactstrap';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import courseServices from '../../../../redux/services/courseServices';
import moduleServices from '../../../../redux/services/moduleServices';

const messages = defineMessages({
  course: {
    id: 'Elearning.course',
    defaultMessage: 'Course',
  },
});

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '56px',
    marginTop: '0',
    marginBottom: '10px',
    fontSize: '16px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
  menu: (base) => ({
    ...base,
  }),
};

const getOptions = (query, callback) => {
  courseServices.getAll().then((data) => {
    const tmp = [];
    data.forEach((_element) => {
      if (_element.label.toLowerCase().includes(query.toLowerCase())) {
        tmp.push({ label: _element.label, value: _element.id });
      }
    });
    tmp.sort((a, b) => (a.label > b.label ? 1 : -1));
    callback(tmp);
  });
};

const renderAsyncSelectField = ({
  input,
  label,
  ...custom
}) => (
  <AsyncSelect
    {...input}
    {...custom}
    isMulti
    cacheOptions
    styles={customStyles}
    onChange={(value) => input.onChange(value)}
    defaultOptions
    loadOptions={(query, callback) => getOptions(query, callback)}
    classNamePrefix="react-Selector"
    onBlur={() => input.onBlur(input.value)}
  />
);

const ElearningCourse = (props) => {
  const { intl, dataform } = props;
  const [moduleList, setModuleList] = useState([]);

  useEffect(() => {
    moduleServices.getModule()
      .then((modules) => {
        let _modules = [];
        const res = [];
        if (dataform
          && dataform.values
          && dataform.values.courses
          && dataform.values.courses.length > 0) {
          dataform.values.courses.forEach((course) => {
            _modules = [..._modules, ...course.listModules];
          });
          modules.forEach((module) => {
            if (_modules.includes(module._id)) {
              res.push(module);
            }
          });
          setModuleList(res);
        }
      });
  }, []);

  const refTable = useRef(null);

  return (
    <Row>
      <Col md={6}>
        <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
          {intl.formatMessage(messages.course)}
        </Typography>
        <Field
          name="courses"
          component={renderAsyncSelectField}
          type="selectCourse"
          label="Course"
        />
      </Col>
      {
        moduleList && moduleList.length > 0
          ? (
            <Col md={6}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                Modules
              </Typography>
              <MaterialTable
                options={{
                  pageSize: 3,
                  toolbar: false,
                }}
                tableRef={refTable}
                title="Modules"
                columns={[
                  {
                    title: 'Name',
                    field: 'name',
                  },
                ]}
                data={moduleList}
              />
            </Col>
          )
          : null
      }
    </Row>
  );
};

ElearningCourse.propTypes = {
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];

  return { initialValues: state.group.selectedGroup, form: name, dataform };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(injectIntl(ElearningCourse));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default NewconnectedGroupForm;
